var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayStar17 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.42105 12.8589L13.6253 16L12.2442 10.08L16.8421 6.09684L10.7874 5.58316L8.42105 0L6.05474 5.58316L0 6.09684L4.59789 10.08L3.21684 16L8.42105 12.8589Z",
  fill: "#333333",
  fillOpacity: 0.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayStar17);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray_star_17.b4990f81759f4e1fb0dbf2d192b8a28e.svg";